import React, { useState, useEffect, useCallback } from 'react'

// Partials
import Btn from 'views/shared/partials/btn'
import Dropdown from 'views/shared/partials/dropdown'
import { Table, TR, TD } from 'views/shared/partials/table'
import Loader from 'views/shared/partials/loader'

// Utils
import { openModal } from 'utils/modals';

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'

// Services
import companyServices from 'services/company'
import { redirect } from 'controllers/navigator'

const CompanyPaymentTypeDetail = (props) => {
	const typeID = props.match.params.id;

	const [data, setData] = useState(false);
	const [installmentData, setInstallmentData] = useState(false);

	const getInstallmentOptions = (typeID) => {
		setInstallmentData(false);
		companyServices.listPaymentInstallments({ company_payment_type_id: typeID, per_page: 9999 }).then((payload) => {
			setInstallmentData(payload.installments);
		});
	}

	const getData = useCallback(() => {
		setData(false);
		companyServices.getCompanyPaymentType(typeID).then((payload) => {
			let templateFields = JSON.parse(payload.payment_type.data_template);
			let dataFields = JSON.parse(payload.data_json);
			dataFields = dataFields ? Object.keys(dataFields).map((key) => {
				let fieldData = dataFields[key];

				if (templateFields[key] === '1' || templateFields[key] === '0') {
					fieldData = dataFields[key] === '1' ? 'Evet' : 'Hayır';
				}

				return {
					key: key,
					// data: dataFields[key],
					data: fieldData,
				};
			}) : [];
			setData({...payload, fields: dataFields});
		});

		getInstallmentOptions(typeID);
	}, [typeID]);

	const deletePaymentType = () => {
		openModal(
			'confirm',
			{
				message: data.payment_type.name + ' isimli ödeme türünü silmek istediğinizden emin misiniz?',
				onConfirm: () => {
					setData(false);
					companyServices.deletePaymentType(data.id).then(() => {
						redirect('settings.companyPaymentTypes');
					}).catch(() => { });
				}
			}
		)
	}

	const deleteInstallment = (installment) => {
		openModal(
			'confirm',
			{
				message: installment.description + ' isimli taksit seçeneğini silmek istediğinizden emin misiniz?',
				onConfirm: () => {
					companyServices.deletePaymentInstallment(typeID, installment.id).then(() => {
						getInstallmentOptions(typeID);
					}).catch(() => {})
				}
			}
		)
	}

	useEffect(() => {
		getData();
	}, [typeID, getData])

	return (
		<main className="page company-payment-type-detail">
			<Breadcrumbs
				midSections={[
					{href: 'settings.companyPaymentTypes'}
				]} />
			<section className="portlet section detail-info loader-container">
				<Loader loading={!data} />
				{data &&
					<React.Fragment>
						<div className="portlet-header border-bottom">
							<h1 className="portlet-title">{data.api_name} <span className="title-subtitle">{data.payment_type.name}</span></h1>

							<div className="header-controls">
								<Btn
									white small wide
									onClick={() => { openModal('company-payment-type', { paymentTypeID: props.match.params.id, onSuccess: getData }); }}
									icon="edit">
									Bilgileri Düzenle
								</Btn>

								<Btn
									small wide error outline
									icon="trash"
									onClick={deletePaymentType}>
									Sil
								</Btn>
							</div>
						</div>

						<div className="portlet-section">
							<div className="portlet-infobar info-details">
							
							<div className="grid-container">
								<strong className="infobar-title">Ödeme Yöntemi Bilgileri</strong>
									<div className="row">
										<div className="col x6">
											<div className="infobar-section">
												<strong className="section-title">AMEX</strong>
												<span className="section-data">
													{data.amex ? 'Evet' : 'Hayır'}
												</span>
											</div>
										</div>
										{data.fields.map((field, nth) => (
											<div className="col x6" key={nth}>
												<div className="infobar-section">
													<strong className="section-title">{field.key}</strong>
													<span className="section-data">
														{field.data}
													</span>
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</React.Fragment>
				}
			</section>

			{data &&
				<section className="portlet section detail-info">
					<div className="portlet-header border-bottom">
						<h1 className="portlet-title">Taksit Seçenekleri</h1>

						<div className="header-controls">
							<Btn
								white small wide
								onClick={() => {
									openModal(
										'company-payment-installment',
										{
											paymentTypeID: props.match.params.id,
											onSuccess: getData
										}
									);
								}}
								icon="plus">
								Taksit Oluştur
							</Btn>
						</div>
					</div>

					<div className="portlet-section bottom loader-container">
						<Loader loading={!installmentData} />
						{installmentData &&
							<Table 
								emptyMessage="Hiç ödeme bulunmuyor."
								className="list-table"
								heading={
									<React.Fragment>
										<th>ID</th>
										<th>Min. Fiyat</th>
										<th>Taksit Sayısı</th>
										<th>Taksit Açıklaması</th>
										<th>Toplam Taksit</th>
										<th>Vade Farkı Oranı</th>
										<th></th>
									</React.Fragment>
								}>
								{installmentData.map((installment, nth) => (
									<TR key={nth} mobileTitle={'#' + installment.id}>
										<TD hideMobile>
											{installment.id}	
										</TD>
										<TD mobileTitle="Min. Fiyat">
											{installment.min_price}
										</TD>
										<TD mobileTitle="Taksit Sayısı">
											{installment.installment_count}
										</TD>
										<TD className="mobile-full" mobileTitle="Taksit Açıklaması">
											{installment.description}
										</TD>
										<TD mobileTitle="Toplam Taksit">
											{installment.installment_calculate}
										</TD>
										<TD mobileTitle="Vade Farkı Oranı">
											{installment.ratio}
										</TD>
										<TD className="controls">
											<Dropdown
												text="İşlemler"
												icon="list">
												<button
													onClick={() => {
														openModal(
															'company-payment-installment',
															{
																paymentTypeID: props.match.params.id,
																installmentID: installment.id,
																onSuccess: getData
															}
														);
													}}>
													Düzenle
												</button>
												<button
													className="error"
													onClick={() => { deleteInstallment(installment); }}>
													Sil
												</button>
											</Dropdown>
										</TD>
									</TR>
								))}
							</Table>
						}
					</div>
				</section>
			}
		</main>
	)
}

export default CompanyPaymentTypeDetail